import { SugarLanguageServer } from "./LanguageServer/SugarLanguageServer";

const server = new SugarLanguageServer();
server.listen();
